<template>
    <div class="picbook-box">
        <div class="title">
            我是小侦探
        </div>
        <div class="content">
            <picbook
                :picbookData="picbookData"
                :route-name="'studyReport'"
            />
        </div>
    </div>
</template>

<script setup>
import {ref, toRefs, toRef, defineProps, onMounted, defineAsyncComponent} from 'vue';

const props = defineProps(['pageData']);
console.log(props.pageData.opusDetectiveInfo);
const {opusPicbookUrl, opusQuestions} = props.pageData.opusDetectiveInfo;

const data = opusQuestions.map(item => item.voiceUrl);
const picbookData = ref(data);

const arr = opusPicbookUrl.split('?')[0]?.split('/');
const picbook = defineAsyncComponent(() =>
    import(`../../picbook/${arr[arr.length - 1]}.vue`)
);
</script>

<style lang="scss" scoped>
.picbook-box {
    width: 8.51rem;
    height: 6.51rem;
    margin-bottom: .46rem;
    background: url("https://i.gsxcdn.com/2274428489_dlnydt5j.png") 0 0 no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
        margin-top: .5rem;
        margin-bottom: .58rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .45rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
    }

    .content {
        width: 7.23rem;
        height: 4.05rem;
        border-radius: .21rem;
        overflow: hidden;
        position: relative;
        z-index: 1;
    }
}
</style>
